export const AI_CONSTANTS = {
    BOT_NAME: 'Alfred',
};
